// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3_ZYB","title":"Info_title__2S4-i","links":"Info_links__1GS4x","link":"Info_link__1khkr","logo":"Info_logo__1ze6r"};